package com.tixforgigs.common.ui.components.mandarin

import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import io.kvision.core.Container
import io.kvision.event.clickFlow
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.button.filledButton
import io.kvision.material.icon.icon
import io.kvision.material.iconbutton.filledIconButton
import io.kvision.state.bind
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach

@OptIn(ExperimentalMaterialApi::class)
fun Container.mandarinFilledButton(
  title: String,
  isEnabled: StateFlow<Boolean> = MutableStateFlow(true),
  materialIconName: String? = null,
  onClick: suspend () -> Unit = {}
) {
  filledButton(className = "xm-button") {
    text = title
    materialIconName?.let { icon(it) }
  }.bind(isEnabled) { inputsValid ->
    disabled = inputsValid.not()
  }.clickFlow.onEach {
    onClick()
  }.launchIn(AppScope)
}

@OptIn(ExperimentalMaterialApi::class)
fun Container.mandarinFilledIconButton(
  materialIconName: String,
  isEnabled: StateFlow<Boolean> = MutableStateFlow(true),
  onClick: suspend () -> Unit = {}
) {
  filledIconButton {
    icon(materialIconName)
  }.bind(isEnabled) { enabled ->
    disabled = enabled.not()
  }.clickFlow.onEach {
    onClick()
  }.launchIn(AppScope)
}